import React from 'react';
import { Handle, Position } from '@xyflow/react';

export default function AiModelNode({ data, selected }) {
  return (
    <div
      className={data?.__animateAppear ? 'workflow-node-appear' : undefined}
      style={{
        padding: '10px 14px',
        background: 'var(--card-bg)',
        border: selected ? '2px solid #22c55e' : '1px solid #22c55e',
        borderRadius: '8px',
        minWidth: 120,
        boxShadow: selected ? '0 0 0 2px rgba(34, 197, 94, 0.35)' : '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: '#22c55e', width: 14, height: 14, borderRadius: '50%' }} />
      <div style={{ fontWeight: 600, marginBottom: 4, color: 'var(--text-primary)' }}>AI model</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{data?.label ?? 'Model'}</div>
      <Handle type="source" position={Position.Right} style={{ background: '#22c55e', width: 14, height: 14, borderRadius: '50%' }} />
    </div>
  );
}
